/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {TrackingSectionContext} from '../../../types';
import {
  DetailedPageInfo,
  TrackingClientState,
  TrackingClientStateHolder,
} from './clientState';
import {exists} from './exists';
import {stringifyEventData} from './stringifyEventData';

export const getSourceHistory = ({
  index,
  state,
}: {
  index: number;
  state: TrackingClientState;
}): DetailedPageInfo | null => {
  const historySize = state.pageHistory.length;

  if (historySize - 1 - index >= 0) {
    return state.pageHistory[historySize - 1 - index]!;
  } else {
    return null;
  }
};

export const getSourceHistoryString = ({
  index,
  state,
  section,
}: {
  index: number;
  state: TrackingClientState;
  section?: TrackingSectionContext;
}) => {
  const historyItem = getSourceHistory({index, state});

  if (!exists(historyItem)) {
    return null;
  }

  const sectionType = section?.type ?? historyItem.sectionType;
  const sectionTypeId = (() => {
    if (
      section?.type === 'reco' ||
      // return fashion update reco type
      (section?.type === 'stream' && section.recoType)
    ) {
      return section.recoType;
    } else {
      // return content block type and ID
      if (section?.type === 'simple' && section.blockTypeAndId) {
        return section.blockTypeAndId;
      }

      return historyItem.sectionTypeId;
    }
  })();

  const linkedContentType =
    section?.linkedContent ?? historyItem.linkedContentType;
  const linkedContentTypeId =
    section?.linkedContentId ?? historyItem.linkedContentTypeId;

  return stringifyEventData([
    historyItem.page.type,
    historyItem.page.id,
    sectionType,
    sectionTypeId,
    linkedContentType,
    linkedContentTypeId,
  ]);
};

export interface SourceHistoryEventData {
  source: string | null;
  sourceHistoryOne: string | null;
  sourceHistoryTwo: string | null;
  sourceHistoryThree: string | null;
}

export const getSourceHistoryEventData = ({
  state,
  currentSourceSection,
}: {
  state: TrackingClientState;
  currentSourceSection?: TrackingSectionContext;
}): SourceHistoryEventData => {
  return {
    source: getSourceHistoryString({
      index: 0,
      state,
      section: currentSourceSection,
    }),
    sourceHistoryOne: getSourceHistoryString({index: 1, state}),
    sourceHistoryTwo: getSourceHistoryString({index: 2, state}),
    sourceHistoryThree: getSourceHistoryString({index: 3, state}),
  };
};

export const addContainerToHistory = ({
  section,
  clientState,
}: {
  section: TrackingSectionContext;
  clientState: TrackingClientStateHolder;
}) => {
  const currentState = clientState.getCurrent();
  const currentPage = getSourceHistory({index: 0, state: currentState});
  if (!currentPage) {
    return currentState;
  }

  const historyBeforeCurrent = currentState.pageHistory.slice(
    0,
    currentState.pageHistory.length - 1
  );

  return clientState.update({
    pageHistory: [
      ...historyBeforeCurrent,
      {
        ...currentPage,
        sectionType: section.type,
        sectionTypeId: section.type === 'reco' ? section.recoType : undefined,
        linkedContentType: section.linkedContent,
        linkedContentTypeId: section.linkedContentId,
      },
    ],
  });
};
